// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__G1leY","modal":"styles_modal__tn7xC"};